/* eslint-disable */
import RestTypeEntity from "../Entity/RestType";

let RestTypeFactory = function(name, id) {
	var resort = new RestTypeEntity();
	if(typeof id != "undefined") {
		resort.set('id', id);
	}
	
	if(typeof name != "undefined") {
		resort.set('name', name);
	}

	return resort;
};

export default RestTypeFactory;